import { colors } from '../common/colors';
import { palette as defaultPalette } from '../common/palette';

export const secondary = {
    main: colors.themes.purple.primary,
    contrastText: colors.black,
};

export const common = {
    ...colors,
    ...colors.themes.purple,
};

export const palette = {
    ...defaultPalette,
    secondary,
    common,
    action: {
        active: colors.themes.purple.primaryLightSelected,
        hover: colors.themes.purple.primaryLightHover,
        selected: colors.themes.purple.primaryLightSelected,
        focus: colors.themes.purple.primaryLightSelected,
    },
};
